// extracted by mini-css-extract-plugin
module.exports = {"passport_thumbnail_carousel":"PassportThumbnailCarousel_passport_thumbnail_carousel__Z0Xf4","splide__arrow":"PassportThumbnailCarousel_splide__arrow__QvAam"};